// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: row;
  height: max-content;
  -webkit-user-select: none;
          user-select: none;
  width: max-content;
}
:host .size-12,
:host .size-16,
:host .size-20,
:host .size-24,
:host .size-36 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
:host .size-12 > img,
:host .size-16 > img,
:host .size-20 > img,
:host .size-24 > img,
:host .size-36 > img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  transition: all 0.3s ease-in-out;
}
:host .size-12 {
  height: 12px;
  width: 12px;
}
:host .size-12 > img {
  width: 7px;
}
:host .size-16 {
  height: 16px;
  width: 16px;
}
:host .size-16 > img {
  width: 9.33px;
}
:host .size-20 {
  height: 20px;
  width: 20px;
}
:host .size-20 > img {
  width: 11.67px;
}
:host .size-24 {
  height: 24px;
  width: 24px;
}
:host .size-24 > img {
  width: 14px;
}
:host .size-36 {
  height: 36px;
  width: 36px;
}
:host .size-36 > img {
  width: 21px;
}
:host .exceptions > img {
  display: flex;
  flex-direction: row;
}

.auto {
  cursor: auto;
}

.default {
  cursor: default;
}

.pointer {
  cursor: pointer;
}

.crosshair {
  cursor: crosshair;
}

.move {
  cursor: move;
}

.text {
  cursor: text;
}

.wait {
  cursor: wait;
}

.help {
  cursor: help;
}

.progress {
  cursor: progress;
}

.not-allowed {
  cursor: not-allowed;
}

.underline {
  text-decoration: underline;
}

.lineThrough {
  text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/atoms/atm-icon/atm-icon.component.scss","webpack://./src/styles/_displayed.scss"],"names":[],"mappings":"AAEA;ECYE,aAAA;EAKA,mBAAA;EDfA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAAF;AACE;;;;;ECOA,aAAA;EAmBA,sBAAA;EAIA,mBAAA;EACA,uBAAA;ADtBF;AAFI;;;;;EACE,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gCAAA;AAQN;AAJE;EACE,YAAA;EACA,WAAA;AAMJ;AALI;EACE,UAAA;AAON;AAHE;EACE,YAAA;EACA,WAAA;AAKJ;AAJI;EACE,aAAA;AAMN;AAFE;EACE,YAAA;EACA,WAAA;AAIJ;AAHI;EACE,cAAA;AAKN;AAFE;EACE,YAAA;EACA,WAAA;AAIJ;AAHI;EACE,WAAA;AAKN;AADE;EACE,YAAA;EACA,WAAA;AAGJ;AAFI;EACE,WAAA;AAIN;AACI;EChDF,aAAA;EAKA,mBAAA;AD8CF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,6BAAA;AAFF","sourcesContent":["@use 'displayed' as d;\n\n:host {\n  @include d.flex-row;\n  height: max-content;\n  user-select: none;\n  width: max-content;\n  .size-12,\n  .size-16,\n  .size-20,\n  .size-24,\n  .size-36 {\n    @include d.flex-column;\n    @include d.flex-center-items;\n    & > img {\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: contain;\n      transition: all 0.3s ease-in-out;\n    }\n  }\n\n  .size-12 {\n    height: 12px;\n    width: 12px;\n    & > img {\n      width: 7px;\n    }\n  }\n\n  .size-16 {\n    height: 16px;\n    width: 16px;\n    & > img {\n      width: 9.33px;\n    }\n  }\n\n  .size-20 {\n    height: 20px;\n    width: 20px;\n    & > img {\n      width: 11.67px;\n    }\n  }\n  .size-24 {\n    height: 24px;\n    width: 24px;\n    & > img {\n      width: 14px;\n    }\n  }\n\n  .size-36 {\n    height: 36px;\n    width: 36px;\n    & > img {\n      width: 21px;\n    }\n  }\n\n  .exceptions {\n    & > img {\n      @include d.flex-row;\n    }\n  }\n}\n\n//DOCS: Cursor\n\n.auto {\n  cursor: auto;\n}\n\n.default {\n  cursor: default;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.crosshair {\n  cursor: crosshair;\n}\n\n.move {\n  cursor: move;\n}\n\n.text {\n  cursor: text;\n}\n\n.wait {\n  cursor: wait;\n}\n\n.help {\n  cursor: help;\n}\n\n.progress {\n  cursor: progress;\n}\n\n.not-allowed {\n  cursor: not-allowed;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.lineThrough {\n  text-decoration: line-through;\n}\n","/// Breakpoints names\n$small: 'small';\n$standard: 'standard';\n\n\n/// Breakpoints\n$breakpoints-pqf: ($small: 0px, $standard: 1920px);\n\n@mixin height-width-100 {\n  height: 100%;\n  width: 100%;\n}\n\n@mixin _flex {\n  display: flex;\n}\n\n@mixin _flex-row {\n  @include _flex;\n  flex-direction: row;\n}\n\n@mixin flex-row-wrap {\n  @include _flex-row;\n  flex-wrap: wrap;\n}\n\n@mixin flex-row {\n  @include _flex-row;\n}\n\n@mixin flex-column {\n  @include _flex;\n  flex-direction: column;\n}\n\n@mixin flex-center-items {\n  align-items: center;\n  justify-content: center;\n}\n\n// MediaQuery\n$small-screen: 1366px;\n$medium-screen: 1920px;\n$large-screen: 2560px;\n\n@mixin custom-media-query($size) {\n  @media (min-width: $size) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
